import { config_settings } from '@/config.js';
import Vue from 'vue';

export const getCategories = () => {
  return Vue.$http.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/categories');
};
